<template>
  <div class="teaching-score-input-handle-fetch">
    <slot :start="startFetch"></slot>
    <el-dialog width="320px"
               :visible.sync="visible"
               :append-to-body="true"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               custom-class="teaching-score-input-handle-fetch-dialog">
      <PrepareLayout ref="fetch"
                     :prepare-url="`/workspace/manager/teaching/score/input/schedule/${scoreType}/state`"
                     :auto-start="false"
                     :prepare-params="handleParams"
                     :prepare-active="visible"
                     :prepare-word="fetchText"
                     @prepared="onPrepared">
      </PrepareLayout>
    </el-dialog>
  </div>
</template>

<script>
import PrepareLayout from '../../../../../../../../widgets/custom/PrepareLayout'
export default {
  name: 'TeachingScoreInputHandleFetch',
  components: {
    PrepareLayout
  },
  props: {
    scheduleId: {
      type: String,
      required: true
    },
    scoreType: {
      type: String,
      required: true
    },
    fetchText: {
      type: String,
      default: '成绩数据获取中...'
    }
  },
  data () {
    return {
      visible: false,
      loading: false
    }
  },
  computed: {
    handleParams () {
      return {
        scheduleId: this.scheduleId
      }
    }
  },
  methods: {
    startFetch () {
      this.visible = true
      this.$nextTick(() => {
        this.loading = true
        this.$ajax({
          url: `/workspace/manager/teaching/score/input/schedule/${this.scoreType}/fetch`,
          method: 'post',
          data: this.$qs.stringify(this.handleParams)
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                const fetch = this.$refs.fetch
                if (fetch) {
                  fetch.prepare()
                }
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                this.$nextTick(() => {
                  this.visible = false
                })
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
          this.$nextTick(() => {
            this.visible = false
          })
        }).finally(() => {
          this.loading = false
        })
      })
    },
    onPrepared (bundle) {
      this.visible = false
      this.$nextTick(() => {
        this.$emit('fetched', bundle.result || {})
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-handle-fetch {
    display: inline-block;
  }
  .teaching-score-input-handle-fetch-dialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      .prepare-layout {
        height: 100px;
      }
    }
  }
</style>
